<template>
  <div>
    <div class="brand_infoBox text-center mt50">
      <h1 class="brand_logo"></h1>
    </div>
    <div class="fullbox" :style="{'width': window.width + 'px', 'height': windowHeight + 'px'}">
      <div class="fullbox_cont text-center">
        <div class="anime_Connent">
          <div class="changeBikeBox">
            <span class="icon-bikechange_arrow"></span>
          </div>
          <div class="lineLoading">
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
          </div>
          <span class="icon-bikechange_tab"></span>
        </div>
        <div class="greyBox mt50">
          <p>{{ $t('changeBike.titleChangeBike') }}</p>
        </div>
        <p>{{ $t('changeBike.titleDisconnectBike') }}</p>
        <ul class="bike_connectList list_titleStyle list-unstyled">
          <li :data-tit="$t('connectBike.step1')">{{ $t('changeBike.unplugYourDongle') }}</li>
          <li :data-tit="$t('connectBike.step2')">{{ $t('changeBike.turnOnTheBikePower') }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { windowsResize } from '@/mixins/windows-resize';
import { bikeWbConnectAPI } from '@/mixins/websocket-api';
import { connectJsBikeApi } from '@/mixins/connect-bike-api';

export default {
  name: 'ChangeBike',
  mixins: [bikeWbConnectAPI, connectJsBikeApi, windowsResize],
  computed: {
    windowHeight () {
      let oriHeight = this.window.height;
      if (oriHeight !== null) {
        oriHeight -= 131;
      }
      return oriHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
.fullbox {
  position: relative;
  overflow: hidden;
}

.fullbox_cont {
  @include pc-width {
    width: 580px;
  }
}

.anime_Connent {
  @include flexbox(flex, nowrap, space-around, center);
  margin: {
    left: auto;
    right: auto;
  }
  @include mac-width {
    @include flexbox(flex, nowrap, space-between, center);
  }

  span {
    @include rem(font-size, 15rem);
    @include nb-width {
      @include rem(font-size, 12rem);
    }
  }

  .changeBikeBox {
    position: relative;
    width: 160px;
    height: 150px;
    >span {
      color: $grey;
      @include rem(font-size, 3.8rem);
      position: absolute;
      @extend %center-box;
    }
    &:before, &:after {
      content: '\e902';
      display: inline-block;
      @extend %icons-m;
      @include rem(font-size, 6.6rem);
      position: absolute;
    }
    &:before {
      color: $grey;
      top: -22px;
      left: -30px;
    }
    &:after {
      color: lighten($grey, 20%);
      bottom: -22px;
      right: -30px;
    }
  }

  .icon-bikechange_tab {
    color: $grey;
  }
}

.greyBox {
  background-color: darken($grey, 20%);
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  p {
    color: $white;
    margin: 0;
  }
}

p {
  color: $red;
  @include rem(font-size, 2.8rem);
  margin-top: 66px;
  margin-bottom: 0;
}

.bike_connectList {
  font-size: 0;
  margin-top: 10px;
  padding-left: 120px;
  li {
    @include rem(font-size, 1.8rem);
    text-align: left;
  }
}
</style>
